<template>
	<div class="customer">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">			
			<top-nevleft></top-nevleft>
		 <b-col>
			 <b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">Customer Dashboard</h5>
				</b-col>				
			</b-row>
        <div class="breadcrumb-section mb-5">
            <b-container fluid>
                <b-row>
                    <b-col class="text-left">
                        <h5 class="mt-3 mb-3">MY DASHBOARD</h5>		
                    </b-col>
                    <b-col class="text-right">
                        <h6 class="mt-3 mb-3">HOME / ACCOUNT / DASHBOARD</h6>		
                    </b-col>
                </b-row>
            </b-container>
        </div>
		<b-container fluid>
			<b-row class="mb-3">
				
                <b-col lg="6" md="6" sm="12">
				<b-card class="p-0">
					<coupon-popup></coupon-popup>
				</b-card>
					<b-card class="p-0">
						<referafriend-popup></referafriend-popup>
					</b-card>
                </b-col>
                <b-col lg="6" md="6" sm="12">
                    <p>Hello {{$root.customer_info.custname}} (not {{$root.customer_info.custname}}? <b-link href="/customer/logout">Log out</b-link> )</p>
                    <p>Fromt your account dashboard you can view your recent orders, manage your shipping and billing addresses and edit your password and account details.</p>
                </b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<product-swiper :products="related_products" :showQuickViewListener="$root.showQuickView" heading="Best Selling Products" topage="customerdb"></product-swiper>
		</b-container>
		<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
		
		<quickview :modaldata="$root.quickview_data"></quickview>
	</div>
</template>
<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
import ProductSwiper from "@/components/product-swiper-cd.vue";
import Quickview from "@/components/quickview.vue";
import TreeviewPage from "@/components/common/nevleft.vue";
import Referafriendpopup from "@/components/referafriend-popup.vue";
import Couponpopup from "@/components/coupon-popup.vue";
export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
        "top-header": Header,
		"top-footer": Footer,
		"product-swiper": ProductSwiper,
		"quickview": Quickview,
		"top-nevleft": TreeviewPage,
		"referafriend-popup": Referafriendpopup,
		"coupon-popup": Couponpopup,
	},
	mounted(){
        this.initload();
		//this.$root.$emit('bv::show::modal', 'diwalipopup');
	},
	data() {
		return{
			statusSidebar: false,
            modal_data: {
                price: 0,
                special_price: 0
			},
			slide:0,
			related_products: [],
			url: this.$root.WEBURL+'customer-orders',
			relatedProurl: this.$root.WEBURL+'relatedproducts',
			
		};
	},
	methods: {
		burgerMenuSidebar() {
		  this.statusSidebar = !this.statusSidebar;
		},
		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.modal_data.gallery_images = JSON.parse(item.gallery_images);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		initload(){
			var self = this;
			self.axios.post(self.relatedProurl, {
                accesskey: self.$session.get('access_key'),
                products: 1
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    self.related_products = response.data.result.related_products;
                    //console.log(self.share_data);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		}
	}
}
</script>